import React from 'react';
import PricingCalculator from '../components/PricingCalculator';
import './CalculatorPage.css';

const CalculatorPage = () => {
    return (
        <div className="calculator-page">
            <div className="page-header">
                <h1>OTT Pricing Calculator</h1>
                <p className="page-description">
                    Calculate your streaming platform costs and revenue projections with our comprehensive pricing tool.
                    Configure your requirements and see detailed cost breakdowns for different packages.
                </p>
            </div>
            <PricingCalculator />
        </div>
    );
};

export default CalculatorPage;
